import { FC, useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { useCart } from 'frontastic/provider';
import { CheckoutBody } from './checkout-body';
import { CheckoutHeader } from './checkout-header';
import { CheckoutProvider } from '../contexts/checkout.context';
import { DEFAULT_CUTOFF_TIME, DEFAULT_TIMEZONE } from '../../../../helpers/dateHelpers';

export const CheckOutMultiSteps: FC = (props: any) => {
  const { 
    shipSpeedData, 
    shippingInfo,
    cutoffTime = DEFAULT_CUTOFF_TIME,
    cutoffTimezone = DEFAULT_TIMEZONE,
    shipDateTable = [],
    transitDaysByMethod = [],
  } = props.data;
  const cart = useCart();
  const [shippingMethods, setShippingMethods] = useState<any[] | null>(null);
  const { data } = cart;
  const router = useRouter();

  useEffect(() => {
    (async () => {
      const methods = data?.availableShippingMethods ?? [];
      const wrappedMethods = methods.shippingMethods?.map((method) => {
        return {
          id: method.key,
          title: method.label,
          turnaround: method.description,
          price: methods.shippingByCart[method.key],
        };
      });
      setShippingMethods(wrappedMethods);
      if (!props.data) router.push('/cart');
    })();
  }, [data]);

  if (!cart.data || !props.data || !shippingMethods) {
    return <></>;
  }

  return (
    <CheckoutProvider
      states={props.data?.provinces?.dataSource?.value}
      shippingMethods={shippingMethods}
      shipSpeedData={shipSpeedData}
      shippingInfo={shippingInfo}
      unavailabledDates={props.data?.unavailableDates}
      beyondTodayDate={props.data?.bfp}
      undatePattern={props.data?.undatePattern}
      dateOverrides={props.data?.dateOverrides}
      cutoffTime={cutoffTime}
      cutoffTimezone={cutoffTimezone}
      shipDateTable={shipDateTable}
      transitDaysByMethod={transitDaysByMethod}
    >
      <CheckoutHeader />
      <CheckoutBody />
    </CheckoutProvider>
  );
};
